import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import AdminPagesListHeader from './ListHeader';
import AdminPagesListItem from './ListItem';

const AdminPagesList = ({
  pages,
  loadPages,
  deletePageFromList,
  ...props
}) => (
  <div className="table-wrapper">
    <Table className="users-list pages-list" responsive>
      <thead>
        <AdminPagesListHeader
          {...props}
        />
      </thead>
      <tbody>
        {pages.map(page => (
          <AdminPagesListItem
            key={page.id}
            page={page}
            loadPages={loadPages}
            deletePageFromList={deletePageFromList}
          />
        ))}
      </tbody>
    </Table>
  </div>
);

AdminPagesList.propTypes = {
  pages: PropTypes.array.isRequired,
  loadPages: PropTypes.func.isRequired,
  deletePageFromList: PropTypes.func.isRequired,
};

export default AdminPagesList;
